import axios from 'axios';

export const saveMessage = (doc) => async () =>  {
  try{
    const response = await axios.post(`${process.env.REACT_APP_SERVER_BASE_URL}/help-center/save-message`, doc);
    
    return response.data;
  }catch(err){
    return err;
  }
};
   

export const deleteMessage = (messageId) => async () =>  {
  try{
    const response = await axios.delete(`${process.env.REACT_APP_SERVER_BASE_URL}/help-center?id=${messageId}`);
    
    return response.data;
  }catch(err){
    return err;
  }
};

export const getMessages = (userObjectId) => async () =>  {
  try{
    const response = await axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/help-center/messages?id=${userObjectId}`);
    
    return response.data;
  }catch(err){
    return err;
  }
};

export const getChats = () => async () =>  {
  try{
    const response = await axios.get(`${process.env.REACT_APP_SERVER_BASE_URL}/help-center/chats`);
    
    return response.data;
  }catch(err){
    return err;
  }
};

export const markMessagesSeen = (userId, messageIds) => async () =>  {
  try{
    const response = await axios.put(`${process.env.REACT_APP_SERVER_BASE_URL}/help-center/seen-messages`,{
      userId,
      ids: messageIds
    });
    
    return response.data;
  }catch(err){
    return err;
  }
};